import icons from 'url:../../img/icons.svg';

export default class MainView {
  _data;

  _clear() {
    this._parentElement.innerHTML = '';
  }

  _insertMarkup(markup) {
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  renderContent(data) {
    if (!data || (Array.isArray(data) && data.length === 0)) {
      this.renderError();
      return;
    }

    this._data = data;
    const markup = this._generateMarkup();
    this._clear();
    this._insertMarkup(markup);
  }

  updateContent(data) {
    this._data = data;
    const updatedMarkup = this._generateMarkup();
    const updatedDOM = document
      .createRange()
      .createContextualFragment(updatedMarkup);
    const updatedElements = Array.from(updatedDOM.querySelectorAll('*'));
    const currentElements = Array.from(
      this._parentElement.querySelectorAll('*')
    );

    //DOM Updating Algorithm
    updatedElements.forEach((updatedElement, i) => {
      const currentElement = currentElements[i];
      if (
        !updatedElement.isEqualNode(currentElement) &&
        updatedElement.firstChild?.nodeValue.trim() !== ''
      ) {
        currentElement.textContent = updatedElement.textContent;
      }

      if (!updatedElement.isEqualNode(currentElement)) {
        Array.from(updatedElement.attributes).forEach(attribute =>
          currentElement.setAttribute(attribute.name, attribute.value)
        );
      }
    });
  }

  renderSpinner() {
    const markup = `
      <div class="spinner">
        <svg>
          <use href="${icons}#icon-loader"></use>
        </svg>
      </div>`;

    this._clear();
    this._insertMarkup(markup);
  }

  renderError(error = this._errorMessage) {
    const markup = `
      <div class="error">
        <div>
          <svg>
            <use href="${icons}#icon-alert-triangle"></use>
          </svg>
        </div>
        <p>${error}</p>
      </div>`;
    this._clear();
    this._insertMarkup(markup);
  }

  renderMessage(message = this._regularMessage) {
    const markup = `
      <div class="message">
        <div>
          <svg>
            <use href="${icons}#icon-smile"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>`;
    this._clear();
    this._insertMarkup(markup);
  }
}
